"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTO_ACK_USER_TYPES = exports.AUTO_ACK_LIMITS = exports.patientKeyOfDiscipline = exports.disciplineOfPatientKey = exports.AUTO_ACK_PATIENT_KEYS = exports.AUTO_ACK_PATIENT_DISCIPLINES = exports.AUTO_ACK_USER_KEYS = exports.AUTO_ACK_REGEX_KEYS = exports.AUTO_ACK_USER_KEY = void 0;
exports.AUTO_ACK_USER_KEY = {
    USER_ID: "_id",
    DEPARTMENT_ID: "department.id",
    TYPE: "type",
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
};
// Only these two are matched by regex; the backend rejects `isRegex` on any
// other key and requires it on these.
exports.AUTO_ACK_REGEX_KEYS = [
    exports.AUTO_ACK_USER_KEY.FIRST_NAME,
    exports.AUTO_ACK_USER_KEY.LAST_NAME,
];
exports.AUTO_ACK_USER_KEYS = Object.values(exports.AUTO_ACK_USER_KEY);
// Patient scoping is limited to SOC-starter disciplines, stored one key per
// discipline with a "true" / "false" value.
exports.AUTO_ACK_PATIENT_DISCIPLINES = ["SN", "PT", "OT", "SLP"];
exports.AUTO_ACK_PATIENT_KEYS = exports.AUTO_ACK_PATIENT_DISCIPLINES.map(discipline => `socStarter.${discipline}`);
const disciplineOfPatientKey = (key) => key.replace("socStarter.", "");
exports.disciplineOfPatientKey = disciplineOfPatientKey;
const patientKeyOfDiscipline = (discipline) => `socStarter.${discipline}`;
exports.patientKeyOfDiscipline = patientKeyOfDiscipline;
// Mirrors AUTO_ACK_LIMITS on the backend so the form rejects what the API would.
exports.AUTO_ACK_LIMITS = {
    MAX_RULES: 30,
    MAX_GROUPS_PER_RULE: 10,
    MAX_VALUES_PER_GROUP: 30,
    MAX_VALUE_LENGTH: 100,
    MAX_REGEX_LENGTH: 50,
};
// User types the backend accepts — patients and app accounts are not among them.
exports.AUTO_ACK_USER_TYPES = ["ADMIN", "STAFF", "USER", "PHYSICIAN"];
